import DateRangeMenu from 'src/components/Overlays/DateRangeMenu'

import { ACTIVITY_ANALYTICS_EARLIEST_DATE } from '../CallAnalyticsPage/activityAnalyticsDateRange'
import { serializeDateRangeForUrl, updateUrl } from '../CallAnalyticsPage/utils'

interface SMSFiltersBarProps {
  startDate: Date
  setStartDate: (date: Date) => void
  endDate: Date
  setEndDate: (date: Date) => void
}

const SMSFiltersBar = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}: SMSFiltersBarProps) => {

  return (
    <div className="flex flex-row items-center gap-2">
      <DateRangeMenu
        minDate={ACTIVITY_ANALYTICS_EARLIEST_DATE}
        startDate={startDate}
        endDate={endDate}
        handleChange={(value) => {
          setStartDate(value[0])
          setEndDate(value[1])
          updateUrl('dateRange', serializeDateRangeForUrl(value[0], value[1]))
        }}
        clearable={false}
      />
    </div>
  )
}

export default SMSFiltersBar
